import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// MUI
import UploadFileIcon from '@mui/icons-material/UploadFile';

//Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import TableButton from "@/ui/Table/ActionButtons/TableButton";

// Types
import { DCRecord, IDataController, DCFieldValue } from "@/@types/lib/dataController"
import DialogContext from "@/ui/DialogContext/DialogContext";
import StatusDialog from "./KomunalneStatusDialog"
import { DialogContextType } from "@/@types/ui/DialogContext";

type RadniSastanciKomunalneObvezeTableProps = {
    dc: IDataController;
    records: Array<DCRecord>;
    handleOpenExportDialog: (selection: string[]) => void;
    selectedProject: DCFieldValue | null;
    selectedLokacija: DCRecord | null;
    onRowSelect: (id: number, record: DCRecord) => void;
    handleAddKomunalne: () => void;
    rowSelectedCustom?: number;
    statusFields?: DCRecord[];
    refreshRecords?: () => void;
};

let CHANGED_FLAG = false;

function KomunalneObvezeTable (props: RadniSastanciKomunalneObvezeTableProps) {
    const dialogContext = useContext<DialogContextType>(DialogContext);
    const [rowSelected, setRowSelected] = useState<DCRecord|null>(null);
    const locationField = "id";
    const { t } = useTranslation();
    const { dc, records, onRowSelect, handleAddKomunalne, rowSelectedCustom, statusFields, refreshRecords, selectedLokacija } = props;
    

    const handleRowSelect = (id: number) => {
        if (rowSelected === null)
            CHANGED_FLAG = true;
            const record = records.find((r:any) => r.id === id);
        if (record !== undefined) {
            const [rLok, rId] = rowSelected === null ? [-1, -1] : [rowSelected[locationField], rowSelected.id];
        if (record.id === rId && record[locationField] === rLok) {
            setRowSelected(null);
            onRowSelect(Number(record[locationField]), record);
        } else if (record.id !== rId && record[locationField] === rLok) {
            setRowSelected(record);
        }else {
            setRowSelected(record);
            onRowSelect(Number(record[locationField]), record);
        }
        } else {
            setRowSelected(null);
        }
    }

    const showStatusDialog = () => {
        dialogContext.showDialog(StatusDialog, {fields: statusFields});
    }

    const handleDelete = () => {
        if(refreshRecords !== null && refreshRecords) {
            refreshRecords();
        }
    }

    useEffect(() => {
        if (rowSelected !== null) {
            onRowSelect(Number(rowSelected[locationField]), rowSelected);
        }
    }, []);

    // RETURN
    // -------------------------------------------------------------------------------------------
    return (
        <ModelTable
            title={t("titles.komunalne_obveze")}
            records={records}
            dc={dc}
            allowSelection="one"
            viewName="radni_sastanci"
            allowFilter={true}
            allowExport={true}
            disableControls={false}
            initialPageSize={25}
            onRowAction={() => {}}
            onRowClick={handleRowSelect}
            allowRowAction={() => { return true;}}
            allowEdit={true}
            allowDelete={true}
            allowAdd={true}
            handleAdd={handleAddKomunalne}
            gotoFirstPageOnSelect={false}
            rowSelectedCustom={rowSelectedCustom}
            allowInc={false}
            allowLegend={true}
            onLegendClick={showStatusDialog}
            onDeleted={handleDelete}
            defaultGlobalFilter={(selectedLokacija?.id as number)?.toString()}
            trackTableState={true}
        >
        </ModelTable>
    )
}

export default KomunalneObvezeTable


/*
<TableButton
    variant="outlined" 
    allow="many"
    selection={[]}
    onClick={(evt, sel) => handleOpenExportDialog(sel)}
    startIcon={<UploadFileIcon />}
>
    {t("buttons.generate_xml")}
</TableButton>
*/